import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course03 from "../../../course/course-03/course";
import lesson0306 from "../lesson-06/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "1f0d26c4-4a55-47ab-8e1d-ade830e0de3a",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0306),
    lesson: lesson0306,
  },
];

export default lessonLinks;
